import React from 'react';
import { useNavigate } from 'react-router-dom';
import { C, num } from './theme';
import { Empty, Panel } from './KpiGrid';

const Bar = ({ value, max, color }) => (
  <div className="h-2 w-full overflow-hidden rounded-full" style={{ background: C.line }}>
    <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${max ? Math.max(4, (value / max) * 100) : 0}%`, background: color }} />
  </div>
);

const Row = ({ label, sub, value, max, color, testid, onClick }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className="w-full rounded-xl px-2 py-2 text-left transition-colors duration-150 hover:bg-[#FBF9FD]">
    <div className="mb-1.5 flex items-baseline justify-between gap-3">
      <span className="truncate text-[13px] font-semibold" style={{ color: C.ink }}>{label}</span>
      <span className="shrink-0 text-[13px] font-extrabold tabular-nums" style={{ color }}>{value}</span>
    </div>
    {sub && <p className="mb-1.5 text-[11px]" style={{ color: C.muted }}>{sub}</p>}
    <Bar value={typeof max === 'number' ? Number(String(value).replace(/\D/g, '')) : 0} max={max} color={color} />
  </button>
);

export function AcademicBlock({ block, acad }) {
  const navigate = useNavigate();
  const segMax = Math.max(0, ...block.segments.map((s) => s.students));
  const clsMax = Math.max(0, ...acad.by_class.map((c) => c.pending));
  const tMax = Math.max(0, ...acad.teachers.slice(0, 5).map((t) => t.pending));
  return (
    <Panel kicker="Acadêmico" title="Segmentos, turmas e notas" testid="block-academic"
      right={<span className="rounded-full px-3 py-1 text-[11px] font-bold" style={{ background: `${C.purple}14`, color: C.purple }} data-testid="academic-trimestre">{acad.trimestre}</span>}>
      <div className="grid gap-6 md:grid-cols-3">
        <div data-testid="academic-segments">
          <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.18em]" style={{ color: C.muted }}>Alunos ativos por segmento</p>
          {!block.segments.length ? <Empty>Nenhuma turma no filtro.</Empty> : block.segments.map((s) => (
            <Row key={s.segment} label={s.segment} sub={`${num(s.classes)} turma(s)`} value={num(s.students)} max={segMax}
              color={C.purple} testid={`segment-${s.segment}`} onClick={() => navigate('/v2/academico/turmas')} />
          ))}
        </div>
        <div data-testid="academic-pending-classes">
          <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.18em]" style={{ color: C.muted }}>Notas pendentes por turma</p>
          {!acad.by_class.length ? <Empty testid="pending-classes-empty">Nenhuma nota pendente no trimestre.</Empty> : acad.by_class.slice(0, 5).map((c) => (
            <Row key={c.id} label={c.name} sub={c.critical ? `${c.critical} item(ns) crítico(s)` : null} value={num(c.pending)} max={clsMax}
              color={C.orange} testid={`pending-class-${c.id}`} onClick={() => navigate('/v2/academico/pendencias')} />
          ))}
        </div>
        <div data-testid="academic-pending-teachers">
          <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.18em]" style={{ color: C.muted }}>Professores com pendências</p>
          {!acad.teachers.length ? <Empty testid="pending-teachers-empty">Nenhum professor com pendência.</Empty> : acad.teachers.slice(0, 5).map((t) => (
            <Row key={t.id} label={t.name} sub={`${t.classes} turma(s)`} value={num(t.pending)} max={tMax}
              color={C.magenta} testid={`pending-teacher-${t.id}`} onClick={() => navigate('/v2/academico/pendencias')} />
          ))}
        </div>
      </div>
    </Panel>
  );
}
